import * as React from "react";
import {UserResource} from "client/resources";
import {Avatar} from "components/Avatar/Avatar";
import ExternalLink from "components/ExternalLink";

import styles = require("./style.less");

interface GravatarProps {
    user: UserResource;
    size?: number;
}

const Gravatar: React.StatelessComponent<GravatarProps> = props => {

    return <div>
        <Avatar user={props.user} size={props.size} />
        <div>
            You can change your picture at <ExternalLink href="http://g.octopushq.com/Gravatar">Gravatar.com</ExternalLink>
        </div>
    </div>;
};

Gravatar.displayName = "Gravatar";

export default Gravatar;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Gravatar/Gravatar.tsx